export const ordenCoordenadas=(auxLat,auxLng)=>{
    let coordenada=[]
    let aux1=auxLat;            
    aux1=parseFloat(aux1)
    let aux2=auxLng;            
    aux2=parseFloat(aux2)        
    coordenada={ lat : aux1, lng :aux2 }
  return coordenada  
}
